import React from 'react';
import { useLang } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="bg-gradient-to-br from-teal-500 to-cyan-600 text-white w-10 h-10 rounded-lg flex items-center justify-center font-bold text-xl">
                TS
              </div>
              <span className="text-2xl font-bold text-white">TripSoul</span>
            </div>
            <p className="text-sm mb-4">
              Your trusted travel partner for unforgettable journeys across India and the world.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-teal-400 transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="hover:text-teal-400 transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="hover:text-teal-400 transition-colors">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('quickLinks')}</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-teal-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/destinations" className="hover:text-teal-400 transition-colors">
                  Destinations
                </Link>
              </li>
              <li>
                <Link to="/packages" className="hover:text-teal-400 transition-colors">
                  Packages
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-teal-400 transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Popular Destinations */}
          <div>
            <h3 className="text-white font-semibold mb-4">Popular Destinations</h3>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-teal-400 transition-colors cursor-pointer">Shimla & Manali</li>
              <li className="hover:text-teal-400 transition-colors cursor-pointer">Kerala</li>
              <li className="hover:text-teal-400 transition-colors cursor-pointer">Goa</li>
              <li className="hover:text-teal-400 transition-colors cursor-pointer">Dubai</li>
              <li className="hover:text-teal-400 transition-colors cursor-pointer">Maldives</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t('contactUs')}</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <MapPin size={16} className="mt-1 flex-shrink-0 text-teal-400" />
                <span data-testid="footer-address">Abdullah Almubarak Street, Mirqab, Kuwait City</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone size={16} className="flex-shrink-0 text-teal-400" />
                <span data-testid="footer-phone">+965 9797 0461</span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail size={16} className="flex-shrink-0 text-teal-400" />
                <span data-testid="footer-email">tripsoultravels@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} TripSoul Travels and Tourism. {t('rights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
